/* eslint-disable camelcase */
import { extend } from 'vee-validate';
import _ from 'lodash'
import {
  required,
  email,
  alpha,
  numeric,
  alpha_spaces,
  alpha_dash,
  confirmed
} from 'vee-validate/dist/rules';

const veeValidate = () => {
  // No message specified.
  extend('email', email);

  extend('alpha', alpha);

  extend('numeric', numeric);

  extend('alpha_spaces', alpha_spaces);

  extend('alpha_dash', alpha_dash);

  extend('confirmed', confirmed);

  extend('cpf', {
    validate(value) {
      return isValidCPF(value);
    },
    message: 'CPF inválido',
    computesRequired: true
  });

  extend('cep', {
    validate(value) {
      return isValidCep(value);
    },
    message: 'CEP inválido',
  })

  function isValidCep(cep) {
    if (cep === undefined || cep === null) return false;

    if ((cep = cep.replace(/[^\d]/g, '')).length !== 8) return false;

    return true
  }

  function isValidCPF(cpf) {
    if (cpf === undefined || cpf === null) return false;

    if ((cpf = cpf.replace(/[^\d]/g, '')).length !== 11) return false;

    const cpfInvalidos = [
      '00000000000',
      '11111111111',
      '22222222222',
      '33333333333',
      '44444444444',
      '55555555555',
      '66666666666',
      '77777777777',
      '88888888888',
      '99999999999'
    ];

    if (cpfInvalidos.indexOf(cpf) > -1) return false;

    let r, i;
    let s = 0;
    for (i = 1; i <= 9; i++) s += parseInt(cpf[i - 1]) * (11 - i);
    r = (s * 10) % 11;
    if (r === 10 || r === 11) r = 0;
    if (r !== parseInt(cpf[9])) return false;
    s = 0;
    for (i = 1; i <= 10; i++) s += parseInt(cpf[i - 1]) * (12 - i);
    r = (s * 10) % 11;

    if (r === 10 || r === 11) r = 0;

    if (r !== parseInt(cpf[10])) return false;

    return true;
  }

  // Override the default message.
  extend('required', {
    ...required,
    message: 'O campo é obrigatório'
  });

  let errorMessage = ''
  extend('documentosObrigatorios', {
    validate (values) {
      if (!values) {
        return false
      }

      const { documentos, documentosObrigatorios } = values

      const errors = []
      errorMessage = '\n\n'

      for (let i = 0; i < documentosObrigatorios.length; i++) {
        const docFound = _.find(documentos, item => item.tipoDocumento.codigo === documentosObrigatorios[i].codigo)

        if (!docFound) {
          errors.push(documentosObrigatorios[i].descricao + ' é obrigatório.')
          errorMessage += '  - ' + documentosObrigatorios[i].descricao + ' é obrigatório \n\n'
        }
      }

      return errors.length > 0 ? errorMessage : true
    }
  })

  extend('confirmed', {
    ...confirmed,
    message: 'Os e-mails informados devem ser iguais'
  });
};

export default veeValidate;
